export default {
      id: "title-technics-usage",
      viewBox: "0 0 131 14",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#title-technics",
      toString: function () {
        return this.url;
      }
    }